<app-top-nav></app-top-nav>
<main>
  <section id="left-section">
    @defer (when !loading()) {
    <div class="left-section-container">
      <div class="nav-scroll">
        <mat-nav-list class="site-nav">
          @for (item of mainMenu; track $index) {
            <mat-list-item class="nav-item" [routerLink]="item.route" routerLinkActive="active-link">
              <img
                matListItemIcon
                [src]="'assets/golf/' + item.icon + '.png'"
                alt="{{ item.icon }}"
                class="nav-icon"
                />
              <div matListItemTitle style="color: var(--text-color)">
                {{ item.label.includes('.') ? appStringAPI.getAppString(item.label) : item.label }}
              </div>
            </mat-list-item>
          }
        </mat-nav-list>
      </div>

      @if (showStoreBadges) {
        <div class="store-badges">
          @if (showIosBadge) {
            <a
              class="store-badge"
              [href]="iosAppUrl"
              target="_blank"
              rel="noopener noreferrer"
              style="width: 160px"
              >
              <img
                src="https://res.cloudinary.com/bleachr/image/upload/v1568755748/bleachr-webclient/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg"
                alt="Download on the App Store"
                />
            </a>
          }
          @if (showAndroidBadge) {
            <a
              class="store-badge"
              [href]="androidAppUrl"
              target="_blank"
              rel="noopener noreferrer"
              >
              <img
                src="https://res.cloudinary.com/bleachr/image/upload/v1568755707/bleachr-webclient/google-play-badge.png"
                alt="Get it on Google Play"
                />
            </a>
          }
        </div>
      }

      <footer class="left-section-footer">
        <div class="social-container">
          @for (social of socialLinks; track $index) {
            <div class="t1-social">
              <a [href]="social.link" class="social-link" target="_blank">
                <img [src]="social.dark_icon_url" class="social-icon" />
              </a>
            </div>
          }
        </div>

        @for (link of footerLinks; track $index) {
          <span (click)="openLink(link.route)" class="footer-link">
            {{ appStringAPI.getAppString(link.label) }}
          </span>
        }

        <div>&copy; {{ currentYear }} GolfONE</div>
      </footer>
    </div>
    } @placeholder {
    <app-loading-indicator style="width: 278px"></app-loading-indicator>
  }
</section>

<section id="center-section">
  <router-outlet></router-outlet>
  <app-ticker-information></app-ticker-information>
</section>
<!-- <section id="right-section">
<app-now-section></app-now-section>
</section> -->
</main>
